import { useQuery } from "react-query";
import { cacheKeys } from "config";
import { existingBlocksClient } from "../client/existingBlocksClient";

export const useExistingBlocksData = (fieldIdSearch?: string, contentTypeFilter: string[] = []) => {
  const { data: existingBlocksData, isLoading } = useQuery(
    [cacheKeys.existingBlocks.getExistingBlocks, fieldIdSearch, contentTypeFilter],
    () => existingBlocksClient.getExistingBlocks(fieldIdSearch, contentTypeFilter),
  );

  return {
    existingBlocks: existingBlocksData?.data || [],
    isLoading,
  };
};
